export const instrumentNamesDictionary = {
    Acciones: {
        es: "Acciones",
        en: "Stocks",
    },
    Bonos: {
        es: "Bonos",
        en: "Bonds",
    },
    CEDEARS: {
        es: "CEDEARS",
        en: "CEDEARS",
    },
    Cauciones: {
        es: "Cauciones",
        en: "Cautions",
    },
    Futuros: {
        es: "Futuros",
        en: "Futures",
    },
    Letras: {
        es: "Letras",
        en: "Letters",
    },
    "Obligaciones negociables": {
        es: "Obligaciones negociables",
        en: "Trading obligations",
    },
    Opciones: {
        es: "Opciones",
        en: "Options",
    },
    Cheques: {
        es: "Cheques",
        en: "Checks",
    },
    Pagarés: {
        es: "Pagarés",
        en: "Page bonds",
    },
    "obligacionesnegoc": {
        es: "Obligaciones negociables",
        en: "Trading obligations",
    },
    // Usados en ProductTabs.js :
    acciones: {
        es: "Acciones",
        en: "Stocks",
    },
    bonos: {
        es: "Bonos",
        en: "Bonds",
    },
    cedears: {
        es: "CEDEARs",
        en: "CEDEARs",
    },
    cauciones: {
        es: "Cauciones",
        en: "Secured Loans",
    },
    letras: {
        es: "Letras",
        en: "Argentina T-Bills",
    },
    fondos: {
        es: "Fondos",
        en: "Funds",
    },
    "obligaciones negociables": {
        es: "Obligaciones negociables",
        en: "Corporate Bonds",
    },
};
